import { faFlag, faUserSlash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { clsx } from 'clsx';
import { Typography } from '@design-system/components/typography/typography';
import { ModerationMode } from '../model/moderation.types';

const SEGMENTS: { value: ModerationMode; label: string; icon: IconProp }[] = [
  { value: 'reported', label: 'Reported post', icon: faFlag },
  { value: 'blocked', label: 'Blocked users', icon: faUserSlash },
];

type Props = {
  mode: ModerationMode;
  onChange: (mode: ModerationMode) => void;
};

export const ModerationToggle = ({ mode, onChange }: Props) => (
  <div className="flex w-full gap-1 rounded-[14px] bg-[#F5F5F5] p-1">
    {SEGMENTS.map((segment) => {
      const active = segment.value === mode;
      return (
        <button
          key={segment.value}
          type="button"
          onClick={() => onChange(segment.value)}
          aria-pressed={active}
          className={clsx(
            'flex flex-1 items-center justify-center gap-2 rounded-[12px] py-3 transition-colors',
            active ? 'bg-black text-white' : 'bg-transparent text-black',
          )}
        >
          <FontAwesomeIcon icon={segment.icon} className="text-sm" />
          <Typography
            as="span"
            variant="body"
            size="medium"
            className="font-semibold"
          >
            {segment.label}
          </Typography>
        </button>
      );
    })}
  </div>
);
